/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Email_Settings_Notification_DescInputs */

const en_admin_email_settings_notification_desc = /** @type {(inputs: Admin_Email_Settings_Notification_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email address for notifications about new company registrations.`)
};

const de_admin_email_settings_notification_desc = /** @type {(inputs: Admin_Email_Settings_Notification_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Adresse für Benachrichtigungen bei neuen Unternehmensregistrierungen.`)
};

/**
* | output |
* | --- |
* | "Email address for notifications about new company registrations." |
*
* @param {Admin_Email_Settings_Notification_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_email_settings_notification_desc = /** @type {((inputs?: Admin_Email_Settings_Notification_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Email_Settings_Notification_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_email_settings_notification_desc(inputs)
	return en_admin_email_settings_notification_desc(inputs)
});